/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useQueryState } from "./useQueryState";

type Props = {
  scrollToRef: React.RefObject<HTMLElement>;
  enabled: boolean;
};

type UrlProps = {
  page: number;
};

export function useScrollAfterPaging({ scrollToRef, enabled }: Props) {
  const [previousPage, setPreviousPage] = React.useState(0);
  const { state } = useQueryState<UrlProps>();
  const { page = 0 } = state;

  const isFirstRun = React.useRef(true);
  React.useLayoutEffect(() => {
    if (!enabled) {
      return;
    }
    if (isFirstRun.current || previousPage === page) {
      isFirstRun.current = false;
      return;
    }
    scrollToRef.current?.scrollIntoView();
    setPreviousPage(page);
  }, [page, scrollToRef, enabled, previousPage]);
}
